import { NumberFiledValueParsing } from '@src/types'

export const numberFiledValueParsing: NumberFiledValueParsing = {
    de: (value: string) =>
        parseFloat(value.replace(/\./g, '').replace(/,/g, '.')),
    en: (value: string) => parseFloat(value.replace(/,/g, '')),
}
